<template>
  <div>
    <v-layout class="hidden-sm-and-down" align-center>
      <router-link to="/">
        <img src="@/assets/header.png" style="height: 2rem">
      </router-link>
      <v-flex sm3 class="text-md-right subheading">Santoral: {{ santoral }}</v-flex>
      <v-flex sm4>
        <weather/>
      </v-flex>
      <v-flex sm3>
        <IndicatorsMenu/>
      </v-flex>
      <v-flex
        sm4
        class="text-md-right text-capitalize title font-weight-regular"
        v-if="current_user"
      >
        ¡Hola {{ current_user.nickname }}!
        <router-link to="/perfil">
          <v-avatar size="30px">
            <v-img
              v-if="current_user"
              :src="current_user.image"
              alt="Avatar"
              :style="{ cursor: 'pointer'}"
            />
          </v-avatar>
        </router-link>
      </v-flex>
    </v-layout>
    <img src="@/assets/barra.png" class="hidden-sm-and-down" style="height: 0.5rem; width: 50%;">
    <img src="@/assets/barra.png" class="hidden-sm-and-down" style="height: 0.5rem; width: 50%;">
    <nav fixed>
      <ul id="ul_menu">
        <li
          class="submenu"
          id="submenu1"
          @mouseenter="open_menu('megamenu1');background_menu()"
          @mouseleave="reset_menu"
        >
          <a href="#" title="Menu 1" class="head_menu">EN LÍNEA</a>
          <ul
            class="megamenu"
            id="megamenu1"
            @mouseenter="close_menu('megamenu1')"
            @mouseleave="reset_menu"
          >
            <ul>
              <h4 class="head_section">Vacaciones</h4>
              <div v-for="menu in vacationMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Permisos</h4>
              <div v-for="menu in permissionMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Tarjeta de trabajo bien hecho</h4>
              <div v-for="menu in cardWorkMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>description
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Selección</h4>
              <div v-for="menu in selectionMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Desempeño y Desarrollo</h4>
              <div v-for="menu in developmentMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Capacitémonos</h4>
              <div v-for="menu in trainMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Remuneraciones</h4>
              <div v-for="menu in renumerationMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Certificaciones</h4>
              <div v-for="menu in certificationMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
          </ul>
        </li>
        <li
          class="submenu"
          id="submenu2"
          @mouseenter="open_menu('megamenu2');background_menu()"
          @mouseleave="reset_menu"
        >
          <a href="#" title="Menu 2" class="head_menu">INFORMADOS</a>
          <ul
            class="megamenu"
            id="megamenu2"
            @mouseenter="close_menu('megamenu2')"
            @mouseleave="reset_menu"
          >
            <ul>
              <router-link :to="`/noticias`" class="link-format">
                <h4 class="head_section">Noticias</h4>
              </router-link>
              <div v-for="menu in postMenu" :key="menu.id">
                <a
                  :href="menu.link"
                  v-if="menu.link.substring(0,4) == 'http'"
                  class="link-format"
                  target="blank"
                >{{menu.title}}</a>
                <router-link :to="`/${menu.link}`" class="link-format" v-else>
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Políticas</h4>
              <div v-for="menu in politicMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Guardianes del Security</h4>
              <div v-for="menu in guardianMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Cliente Integral</h4>
              <div v-for="menu in integralMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Reconociendo</h4>
              <div v-for="menu in recognizeMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Oportunidades Security</h4>
              <div v-for="menu in opportunityMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Programa Previsional</h4>
              <div v-for="menu in programMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Celebremos</h4>
              <div v-for="menu in celebrateMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Ayuda a la Comunidad</h4>
              <div v-for="menu in helpMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Puertas Abiertas</h4>
              <div v-for="menu in openMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <!-- <ul>
            <h4 class="head_section">Cultura Corporativa</h4>
            <div v-for="menu in cultureMenu" :key="menu.id">
              <router-link :to="`/${menu.link}`" class='link-format'>
                <a>{{menu.title}}</a>
              </router-link>
            </div>
            </ul>-->
            <ul>
              <h4 class="head_section">Tiempo Libre</h4>
              <div v-for="menu in freeMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
          </ul>
        </li>
        <li
          class="submenu"
          id="submenu3"
          @mouseenter="open_menu('megamenu3');background_menu()"
          @mouseleave="reset_menu"
        >
          <a href="#" title="Menu 3" class="head_menu">MIS BENEFICIOS</a>
          <ul
            class="megamenu"
            id="megamenu3"
            @mouseenter="close_menu('megamenu3')"
            @mouseleave="reset_menu"
          >
            <ul>
              <h4 class="head_section">Bonos</h4>
              <div v-for="menu in bonusMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Créditos y Subsidios</h4>
              <div v-for="menu in creditMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Seguros</h4>
              <div v-for="menu in secureMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Becas</h4>
              <div v-for="menu in becaMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Tiempo Libre</h4>
              <div v-for="menu in freeTimeBMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Familia</h4>
              <div v-for="menu in familyMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Celebrando</h4>
              <div v-for="menu in celebrateBMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Programa Yo Elijo Salud y Sustentabilidad</h4>
              <div v-for="menu in helthSMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <ul>
              <h4 class="head_section">Convenios generales</h4>
              <div v-for="menu in covenantGMenu" :key="menu.id">
                <router-link :to="`/${menu.link}`" class="link-format">
                  <a>{{menu.title}}</a>
                </router-link>
              </div>
            </ul>
            <!-- <ul>
            <h4 class="head_section">Convenios colectivos</h4>

            </ul>-->
          </ul>
        </li>
        
      </ul>
      <!-- <hr class="division"> -->
    </nav>
  </div>
</template>

<script>
import config from "@/config";
import axios from "axios";
import Weather from "@/components/General/Weather";
import IndicatorsMenu from "@/components/General/IndicatorsMenu";
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
let santoral = "";
export default {
  components: {
    Weather,
    IndicatorsMenu
  },
  data() {
    return {
      santoral: santoral,
      dialog: false
    };
  },
  methods: {
    ...mapActions("user", ["fetchUser", "fetchCurrentUser"]),
    ...mapActions("user", ["fetchUser", "fetchSelectedUser"]),
    ...mapMutations("menus", ["setMenu"]),
    close_menu(megamenu) {
      let menu = document.getElementById(megamenu);
      menu.addEventListener("click", function(e) {
        if (e.target.tagName === "LI" || e.target.tagName == "A") {
          menu.style.display = "none";
        }
      });
    },
    open_menu(megamenu) {
      document.getElementById(megamenu).style.display = "flex";
    },
    background_menu() {
      document.getElementById("ul_menu").style.backgroundColor = "#FAFAFA";
      document.getElementById("back_menu").style.display = "block";
      document.getElementById("back_menu").style.position = "absolute";
    },
    reset_menu() {
      document.getElementById("back_menu").style.display = "none";
      document.getElementById("back_menu").style.position = "relative";
    },
    goToShowUser(user) {
      this.fetchSelectedUser(this.current_user.id);
      this.$router.push({
        name: "user-show",
        params: { id: this.current_user.id }
      });
    }
  },
  computed: {
    ...mapState("user", ["current_user"]),
    ...mapState("user", ["user"]),
    ...mapGetters("menus", [
      "vacationMenu",
      "postMenu",
      "bonusMenu",
      "permissionMenu",
      "cardWorkMenu",
      "selectionMenu",
      "developmentMenu",
      "trainMenu",
      "renumerationMenu",
      "certificationMenu",
      "postMenu",
      "politicMenu",
      "guardianMenu",
      "integralMenu",
      "recognizeMenu",
      "opportunityMenu",
      "programMenu",
      "celebrateMenu",
      "helpMenu",
      "openMenu",
      "cultureMenu",
      "freeMenu",
      "bonusMenu",
      "creditMenu",
      "secureMenu",
      "becaMenu",
      "freeTimeBMenu",
      "familyMenu",
      "celebrateBMenu",
      "helthSMenu",
      "covenantGMenu",
      "covenantCMenu"
    ])
  }
};
</script>
